import { render } from "./JourneyTitle.vue?vue&type=template&id=8115f974&scoped=true"
import script from "./JourneyTitle.vue?vue&type=script&lang=ts"
export * from "./JourneyTitle.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-8115f974"

export default script